import Vue from 'vue'
import dayjs from "dayjs";
import {
  Dialog
} from 'vant';

let languageList = [{
  key: "zh-CN",
  name: "中文简体"
}, {
  key: "en",
  name: "English"
}];
import setting from "../../static/setting.json";
export default {
  userInfo: undefined,
  isChrome() {
    return (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor))
  },
  setShowTime(start, end) {
    // 判断日期是否一样
    const s = dayjs(start).format('YYYY-MM-DD')
    const e = dayjs(end).format('YYYY-MM-DD')

    if (s == e) {
      let week = new Date(start).getDay()
      let date = ''
      switch (week) {
        case 1:
          date = '周一'
          break;
        case 2:
          date = '周二'
          break;
        case 3:
          date = '周三'
          break;
        case 4:
          date = '周四'
          break;
        case 5:
          date = '周五'
          break;
        case 6:
          date = '周六'
          break;
        case 0:
          date = '周日'
          break;
        default:
          break;
      }
      const st = dayjs(start).format('HH:mm')
      const et = dayjs(end).format('HH:mm')
      return `${st} ~ ${et} ${date} ${s}`
    } else {
      return `${start} ~ ${end}`
    }
  },
  isAdmin() { // 判断登录用户是否是管理员
    const userInfo = this.getUserInfo();
    return userInfo.roleKey && (userInfo.roleKey.includes("supperAdmin") || userInfo.roleKey.includes("admin"));
  },
  setUserInfo(userInfo) { //设置用户信息
    const roleKey = [];
    if (userInfo.roles) {
      userInfo.roles.forEach((role) => {
        roleKey.push(role.roleKey);
      })
    }
    userInfo.roleKey = roleKey;
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    this.userInfo = userInfo;
  },
  getUserInfo() { //获取用户信息
    if (this.userInfo) {
      return JSON.parse(JSON.stringify(this.userInfo));
    } else {
      var userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo);
        return JSON.parse(JSON.stringify(this.userInfo));
      } else {
        return undefined;
      }
    }
  },
  isLogin() { //判断是否登录
    if (this.userInfo) {
      return true;
    }
    return false;
  },
  getQueryParams() {
    const queryParams = new URLSearchParams(window.location.search);
    const params = {};

    for (const [key, value] of queryParams.entries()) {
      params[key] = value;
    }

    return params;
  },
  isHiddenScaleDetails() {
    return setting.hiddenScaleDetailsTenantId.includes(this.getUserInfo().tenantId)
  },
  exitLogin($router) { //退出登录
    const userInfo = this.getUserInfo();
    let tenantId = "";
    if (userInfo) {
      tenantId = userInfo.tenantId;
    }
    if (!tenantId) {
      const queryParams = this.getQueryParams();
      tenantId = queryParams.tenantId;
    }
    localStorage.removeItem("userInfo");
    this.userInfo = undefined;
    $router.push({
      name: 'login',
      query: {
        tenantId: tenantId
      }
    });
  },
  alert(option) {
    if (!option) {
      option = {};
    }
    if (!option.title) {
      option.title = Vue.prototype.bus.$t('common.tips');
    }
    if (!option.confirmButtonColor) {
      option.confirmButtonColor = "#0ebe7f"
    }
    return Dialog.alert(option);
  },
  /**
   * 冒泡排序
   * @param {Object} arr
   */
  bubbleSort(arr, key) {
    let i = arr.length,
      j;
    let tempExchangVal;
    while (i > 0) {
      for (j = 0; j < i - 1; j++) {
        let sort;
        let sort2;
        if (key) {
          sort = arr[j][key];
          sort2 = arr[j + 1][key];
        } else {
          sort = arr[j];
          sort2 = arr[j + 1];
        }
        if (sort > sort2) {
          tempExchangVal = arr[j];
          Vue.set(arr, j, arr[j + 1]);
          Vue.set(arr, j + 1, tempExchangVal);
        }
      }
      i--;
    }
    return arr;
  },
  /**
   * 获取元素距离左边和顶部的位置
   * @param {Object} e
   * @param {Object} type  offsetTop顶部 offsetLeft左边
   * @param {Object} terminationView 遇到该元素的时候不再迭代
   */
  getPosition(e, type, terminationView) {
    let offset = e[type];
    if (e.offsetParent != null && e.offsetParent != terminationView) {
      offset += this.getPosition(e.offsetParent, type, terminationView)
    }
    return offset;
  },
  /**
   * 获取元素的精确数值
   * @param {Object} el
   * @param {Object} key
   */
  getElementBoundingClientRect(el, key) {
    if (key) {
      return el.getBoundingClientRect()[key];
    } else {
      return el.getBoundingClientRect();
    }
  },
  /**
   * 获取多语言列表
   */
  getLanguageList() {
    return JSON.parse(JSON.stringify(languageList));
  },
  /**
   * 获取默认语言
   */
  getDefaultLanguage(language) {
    return "zh-CN";
    if (language) {
      for (let i = 0; i < languageList.length; i++) {
        if (languageList[i].key == language) {
          return language;
        }
      }
    } else {
      let JsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
      JsSrc = JsSrc.toLowerCase();
      if (JsSrc == "zh-cn") {
        return "zh-CN";
      } else if (JsSrc.indexOf("en") != -1) {
        return "en";
      } else {
        for (let i = 0; i < languageList.length; i++) {
          if (languageList[i].key == JsSrc) {
            return JsSrc;
          }
        }
      }
    }
    return "en";
  },
  /**
   * 时间对象转换成时间格式
   * @param {Object} date
   * @param {Object} splitStr
   */
  dateConversionText(date, splitStr, defaultText) {
    if (date) {
      let M = date.getMonth() + 1;
      let y = date.getFullYear();
      let d = date.getDate();
      let h = date.getHours(); //时
      let m = date.getMinutes(); //分
      let s = date.getSeconds(); //秒

      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;
      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;
      if (splitStr == "MM.dd") {
        return M + "." + d;
      } else if (splitStr == "dd") {
        return d;
      } else if (splitStr == "yyyy-MM") {
        return y + "-" + M;
      } else if (splitStr == "yyyy.MM") {
        return y + "." + M;
      } else if (splitStr == "HH:mm") {
        return h + ":" + m;
      } else if (splitStr == "HH:mm:ss") {
        return h + ":" + m + ":" + s;
      } else if (splitStr == "MM.dd HH:mm") {
        return M + "." + d + " " + h + ":" + m;
      } else if (splitStr == "yyyy.MM.dd HH:mm") {
        return y + "." + M + "." + d + " " + h + ":" + m;
      } else if (splitStr == "yyyy-MM-dd HH:mm") {
        return y + "-" + M + "-" + d + " " + h + ":" + m;
      } else if (splitStr == "yyyy-MM-dd HH:mm:ss") {
        return y + "-" + M + "-" + d + " " + h + ":" + m + ":" + s;
      } else if (splitStr == "yyyy.MM.dd") {
        return y + "." + M + "." + d;
      } else if (splitStr == "yyyy-MM-dd") {
        return y + "-" + M + "-" + d;
      } else if (splitStr == "MM.dd HH:mm") {
        return M + "." + d + " " + h + ":" + m;
      } else if (splitStr == "HH:mm") {
        return h + ":" + m;
      } else if (splitStr == "HH:mm:ss_") {
        let str = [];
        if (h != "00") {
          str.push(h);
        }
        str.push(m);
        str.push(s);
        return str.join(":");
      }
    } else {
      return defaultText || "";
    }
  },
  /**
   * 时间格式转化成其他格式
   * @param {Object} timeText
   * @param {Object} splitStr
   */
  timeTextConversionText(timeText, splitStr, defaultText) {
    if (timeText) {
      timeText = timeText.replace(/-/g, "/");
      if (timeText.lastIndexOf(".0") == 19) {
        timeText = timeText.substr(0, 19)
      }
      return this.dateConversionText(new Date(timeText), splitStr);
    } else {
      return defaultText || "";
    }
  },
  /**
   * 时间格式转化成时间戳
   * @param {Object} timeText
   * @param {Object} splitStr
   */
  timeTextConversionTimeStamp(timeText, defaultVal) {
    if (timeText) {
      return Date.parse(new Date(timeText.replace(/-/g, "/")));
    } else {
      return defaultVal == undefined ? 0 : defaultVal;
    }
  },
  /**
   * 时间戳转换成时间格式
   * @param {Object} timeStamp
   * @param {Object} splitStr
   */
  timeStampConversionText(timeStamp, splitStr) {
    if (timeStamp) {
      return this.dateConversionText(new Date(timeStamp), splitStr);
    } else {
      return "";
    }
  },
  guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },
  /**
   * 输入框只能输入英文和数字
   * @param {Object} model
   * @param {Object} key
   */
  onInputLettersAndNumbers(model, key) {
    model[key] = model[key].replace(/[^\d|qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM]/g, '');
  },
  /**
   * 输入框只能输入数字
   * @param {Object} model
   * @param {Object} key
   */
  onInputNumbers(model, key) {
    model[key] = model[key].replace(/\D+/g, '');
  },
  /**
   * 输入框只能输入数字和小数点
   * @param {Object} model
   * @param {Object} key
   */
  onInputNumbers2(model, key) {
    model[key] = model[key].replace(/[^\d|.]/g, '');
  },
  /**
   * 毫秒转时间格式
   * @param {Object} millisecond
   * @param {Object} type
   */
  millisecondToString(millisecond, type) {
    if (type == "HH:mm") {
      let h = parseInt(millisecond / 3600000);
      let m = parseInt((millisecond % 3600000) / 60000);
      if (h < 10) {
        h = "0" + h;
      }
      if (m < 10) {
        m = "0" + m;
      }
      return h + ":" + m;
    } else if (type == "mm:ss") {
      let m = parseInt(millisecond / 60000);
      let s = parseInt(millisecond % 60000 / 1000);
      if (m < 10) {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      return m + ":" + s;
    }
  },
  /**
   * 验证是否是手机号
   * @param {Object} str
   */
  checkMobile(str) {
    let re = /^1\d{10}$/
    if (re.test(str)) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 验证是否是电话号
   * @param {Object} str
   */
  checkPhone(str) {
    let re = /^0\d{2,3}-?\d{7,8}$/;
    if (re.test(str)) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 验证是否是邮箱
   * @param {Object} str
   */
  checkEmail(str) {
    let re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
    if (re.test(str)) {
      return true;
    } else {
      return false;
    }
  },
  isMobile() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
      return true;
    } else {
      return false;
    }
  },
  // 判断两个数组的值是否相同
  arraysAreEqual(arr1, arr2, key) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      let isTrue = false;
      for (let j = 0; j < arr2.length; j++) {
        if (key) {
          if (arr1[i][key] == arr2[j][key]) {
            isTrue = true;
            break;
          }
        } else {
          if (arr1[i] == arr2[j]) {
            isTrue = true;
            break;
          }
        }
      }
      if (!isTrue) {
        return false;
      }
    }
    for (let i = 0; i < arr2.length; i++) {
      let isTrue = false;
      for (let j = 0; j < arr1.length; j++) {
        if (key) {
          if (arr2[i][key] == arr1[j][key]) {
            isTrue = true;
            break;
          }
        } else {
          if (arr2[i] == arr1[j]) {
            isTrue = true;
            break;
          }
        }

      }
      if (!isTrue) {
        return false;
      }
    }
    return true;
  },
  loadCSS(url, isCache = false) {
    let element = document.createElement("link");
    element.setAttribute("rel", "stylesheet");
    element.setAttribute("type", "text/css");
    if (isCache) {
      element.setAttribute("href", url + "?t=" + new Date().getTime());
    } else {
      element.setAttribute("href", url);
    }
    document.head.appendChild(element);
  },
}


// WEBPACK FOOTER //
// ./src/utils/utils.js